export default {
    bindings: {
        tag: '<',
        events: '<',
        onlyUnlinked: '<',
        isLoading: '<'
    },
    controller: 'integrationTableController',
    template: require('../views/integration.table.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/integration/components/integration.table.component.js